import React from 'react';
import PortalSpa from './PortalSpa';
import { MemoryRouter, Route, Switch } from 'react-router';
import { UsageAgreementWall } from './UsageAgreementWall/UsageAgreementWall';
import { NotFoundPage } from './common/ErrorPage/NotFoundPage';

// Type casting for React Router v5 compatibility with React 18
const RouteComponent = Route as any;
const SwitchComponent = Switch as any;
const MemoryRouterComponent = MemoryRouter as any;

function ShellRoute() {
    return (
        <MemoryRouterComponent>
            <SwitchComponent>
                <RouteComponent path="/" exact={true} component={UsageAgreementWall} />
                <RouteComponent path="/error" exact={true} component={NotFoundPage} />
                <RouteComponent path="/portalSpa" exact={true} component={PortalSpa} />
            </SwitchComponent>
        </MemoryRouterComponent>
    );
}

export default ShellRoute;
